var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6627 31.8376C25.7548 31.9234 25.8286 32.0269 25.8799 32.1419C25.9311 32.2569 25.9587 32.381 25.9609 32.5069C25.9631 32.6328 25.94 32.7578 25.8928 32.8745C25.8457 32.9913 25.7755 33.0973 25.6864 33.1864C25.5974 33.2754 25.4914 33.3456 25.3746 33.3927C25.2579 33.4399 25.1329 33.463 25.007 33.4608C24.8811 33.4586 24.757 33.431 24.642 33.3798C24.527 33.3285 24.4235 33.2547 24.3377 33.1626L11.8377 20.6626C11.6621 20.4868 11.5635 20.2485 11.5635 20.0001C11.5635 19.7516 11.6621 19.5133 11.8377 19.3376L24.3377 6.83755C24.5154 6.67195 24.7504 6.5818 24.9933 6.58608C25.2362 6.59037 25.4679 6.68876 25.6397 6.86052C25.8114 7.03229 25.9098 7.26402 25.9141 7.5069C25.9184 7.74978 25.8283 7.98483 25.6627 8.16255L13.8267 20.0001L25.6627 31.8376Z",
    fill: "#E1E7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.3654969f09ff49a0e374decde7e18890.svg";
export { ForwardRef as ReactComponent };